/* eslint-disable */
//import Player from '../util/abstractPlayer'; // abstract player util for youtube / vimeo

export default {
  init() {

    $('.video:not(.video-static)').each( (index, playerTarget) => {
      // create a video property on the div
      playerTarget.video = new Video(playerTarget);
      // play or pause the video

      $(playerTarget).find('.video__thumb').on('click', (e) => {

        if( !playerTarget.video.isPlaying ) {
          playerTarget.video.playVideo();

          document.body.classList.add('noscroll');
        }

        return false;
      });
    });
  },
}

class Video {

  constructor (playerTarget) {

    window.plyr = Plyr;

    this.playerTarget = playerTarget;
    this.$thumb = $(this.playerTarget).find('.video__thumb');
    this.iframe = $(this.playerTarget).find('iframe');
    this.plyrDiv = $(this.playerTarget).find('.plyr');
    this.modal = $('.video-modal');

    if(! this.iframe.length ) {
      return;
    }

    // set some controls
    this.player = false;
    this.isPlaying = false;
    this.ready = false;
    this.playVideo = this.playVideo.bind(this);
    this.stopVideo = this.stopVideo.bind(this);
  }


  playVideo() {

    if(! this.hasLoaded) { // if video's being played for the first time..
      this.loadInModal();
    }

    this.hasLoaded = true;

    $(this.playerTarget).trigger('initplay');
    $(this.playerTarget).addClass('video--playing');

    this.$thumb.addClass('video__thumb--hidden');

    this.setCursorLoading();

    this.pollReady = setInterval(() => {
      if(this.ready) {
        setTimeout(() => {
          this.player.play();
          $(this.playerTarget).trigger('playvideo');
        }, 2000) // vimeo seems to trigger ready too early.
        clearInterval(this.pollReady);
      }
    }, 200);

  }
// need a close all
  stopVideo() {
    if(! this.player ) {
      return;
    }

    this.player.destroy();
    $(this.playerTarget).removeClass('video--playing');

    document.body.classList.remove('noscroll');

    this.$thumb.removeClass('video__thumb--hidden');

    $(this.playerTarget).trigger('stopvideo');

    this.hasLoaded = false;
    this.modal.removeClass('visible');

    this.modal.empty();
    this.player = false;
    //this.player.pause();
  }

  loadInModal() {

    let dataSrc = $(this.iframe).data('src');

    this.modal.addClass('visible');

    let plyrDiv = $(this.playerTarget).find('.plyr').clone();
    this.modal.html(plyrDiv);

    this.modal.find('iframe').attr('src', dataSrc);
    this.hasLoaded = true;

    //if(! this.player) {
      this._setPlayer();
   // }
  }

  _setPlayer() {

    let player = this.modal.find('.plyr');
window.player = player;
    this.player = new Plyr(player, {
      clickToPlay: false,
      autopause: false,
      debug: true,
      hideControls: false,
      controls: ['stop', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions','fullscreen']
    });

    $(player).on('ready', () => {
        this.ready = true;
        // add a stop button
        this.modal.prepend('<span class="button--close"></span>');

        this.modal.find('.button--close').on('click', () => {
          this.setCursorPlay();
          this.stopVideo();
          this.isPlaying = false;
        });
    });

    $(player).on('ended', () => {
      this.isPlaying = false;
      this.setCursorPlay();
      this.stopVideo();
    });

    $(player).on('playing', () => {
      this.isPlaying = true;
      this.setCursorNone();
      // pause other players.
      this.closeOtherPlayers();
    });

  }

  closeOtherPlayers() {

    /*
    plyr.get().forEach(function(instance) {
      if(instance !== this.player) {
        instance.pause();
      }
    });
    */
  }

  setCursorPause() {
    if(window.cursor.hoveredElement) {
      window.cursor.hoveredElement.data('cursor', 'pointer--pause');
      window.cursor.changeCursor('pointer--pause');
    }
    $(this.playerTarget).find('[data-mobile-pointer]').hide();
  }

  setCursorClose() {
    if(window.cursor.hoveredElement) {
      $(this.iframe).parent().data('cursor', 'pointer--close');
      window.iframe = this.iframe;
      window.cursor.changeCursor('pointer--close');
    }
    $(this.playerTarget).find('[data-mobile-pointer]').hide();
  }

  setCursorLoading() {
    if(window.cursor.hoveredElement) {
      window.cursor.changeCursor('pointer--loading');
      $(this.iframe).parent().data('cursor', 'pointer--loading');
    } else {
      window.cursor.updateIconsForMobile($(this.playerTarget).find('[data-mobile-pointer]'), 'pointer--loading');
    }
  }

  setCursorPlay() {
    if(window.cursor.hoveredElement) {
      $(this.playerTarget).data('cursor', 'pointer--play');
      window.cursor.changeCursor('pointer--play');
    } else {
      $(this.playerTarget).find('[data-mobile-pointer]').show();
      window.cursor.updateIconsForMobile($(this.playerTarget).find('[data-mobile-pointer]'), 'pointer--play');
    }
  }

  setCursorNone() {
    if(window.cursor.hoveredElement) {
      $(this.playerTarget).data('cursor', '');
      window.cursor.changeCursor('');
    } else {
      $(this.playerTarget).find('[data-mobile-pointer]').show();
      window.cursor.updateIconsForMobile($(this.playerTarget).find('[data-mobile-pointer]'), '');
    }
  }

  destroy() {
    this.isPlaying = false;
    this.hasLazyLoaded = false;
    this.ready = false;

   // this.player.destroy();
    // rewrap after destroy


     // this.iframe = $(this.playerTarget).find('iframe');

  //    $(this.iframe).wrapAll('<div class="plyr"></div>');
    this.plyrDiv = $(this.playerTarget).find('.plyr').replaceWith(this.plyrDivCopy);
    this.player.destroy();
  }
}

export { Video }



// WEBPACK FOOTER //
// ./scripts/blocks/video.js